"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _definitions = require("@ppay/definitions");
var _ui = require("../../../ui");
var _portfolioCard = require("../../portfolioCard");
var _utils = require("../../../../utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var arrowRotate = function arrowRotate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 15V13H3.41L15 1.41L13.59 0L2 11.59V5H0V15H10Z",
    fill: "currentColor"
  }));
};
arrowRotate.defaultProps = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var wallet = function wallet(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 15V16C18 17.1 17.1 18 16 18H2C0.89 18 0 17.1 0 16V2C0 0.9 0.89 0 2 0H16C17.1 0 18 0.9 18 2V3H9C7.89 3 7 3.9 7 5V13C7 14.1 7.89 15 9 15H18ZM9 13H19V5H9V13ZM13 10.5C12.17 10.5 11.5 9.83 11.5 9C11.5 8.17 12.17 7.5 13 7.5C13.83 7.5 14.5 8.17 14.5 9C14.5 9.83 13.83 10.5 13 10.5Z",
    fill: "currentColor"
  }));
};
wallet.defaultProps = {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Label = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  cursor: pointer;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display:none;\n  "]))));
var ActiveZoneWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &:not(:last-of-type) {\n    margin-right: 20px;\n  }\n"])));
var SeparativeLine = (0, _styledComponents.default)(_ui.SeparativeLine)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var TotalBalance = (0, _styledComponents.default)(_portfolioCard.PortfolioCardTotalBalance)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 20px;\n"])));
var Component = function Component(_ref) {
  var walletsPath = _ref.walletsPath,
    withdrawPath = _ref.withdrawPath,
    replenishPath = _ref.replenishPath,
    className = _ref.className,
    loading = _ref.loading,
    minPercentBalances = _ref.minPercentBalances,
    otherBalanceTotal = _ref.otherBalanceTotal,
    totalBalance = _ref.totalBalance;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libCommon', 'libWallets']),
    t = _useTranslation.t;
  var history = (0, _reactRouterDom.useHistory)();
  return /*#__PURE__*/_react.default.createElement(_ui.Card, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, null, /*#__PURE__*/_react.default.createElement(_ui.CardTitle, null, t('libWallets:title')), /*#__PURE__*/_react.default.createElement(_ui.CardSubtitle, null, t('libWallets:subtitle'))), /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, loading ? /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    color: "primary"
  }) : /*#__PURE__*/_react.default.createElement(_portfolioCard.PortfolioCardChart, {
    balances: minPercentBalances,
    otherBalances: otherBalanceTotal,
    pieSize: 192
  }), /*#__PURE__*/_react.default.createElement(TotalBalance, {
    label: t('libWallets:totalBalance'),
    value: totalBalance,
    ticker: _definitions.Ticker.USD
  }), /*#__PURE__*/_react.default.createElement(SeparativeLine, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(ActiveZoneWrapper, {
    onClick: function onClick() {
      return history.push(withdrawPath);
    }
  }, /*#__PURE__*/_react.default.createElement(Label, null, t('send')), /*#__PURE__*/_react.default.createElement(_ui.RoundButton, {
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: arrowRotate,
      rotate: 180
    })
  })), /*#__PURE__*/_react.default.createElement(ActiveZoneWrapper, {
    onClick: function onClick() {
      return history.push(replenishPath);
    }
  }, /*#__PURE__*/_react.default.createElement(Label, null, t('receive')), /*#__PURE__*/_react.default.createElement(_ui.RoundButton, {
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: arrowRotate
    })
  })), /*#__PURE__*/_react.default.createElement(ActiveZoneWrapper, {
    onClick: function onClick() {
      return history.push(walletsPath);
    }
  }, /*#__PURE__*/_react.default.createElement(Label, null, t('wallets')), /*#__PURE__*/_react.default.createElement(_ui.RoundButton, {
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: wallet
    })
  })))));
};
exports.Component = Component;